import * as React from "react";
import { styled } from "@mui/material/styles";
// import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Typography from "@mui/material/Typography";
import {
  DataGrid,
  Toolbar,
  ToolbarButton,
  ColumnsPanelTrigger,
  FilterPanelTrigger,
  //   ExportCsv,
  //   ExportPrint,
  QuickFilter,
  QuickFilterControl,
  QuickFilterClear,
  QuickFilterTrigger,
  //   GridToolbar,
  GridFilterPanel,
} from "@mui/x-data-grid";
// import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import FilterListIcon from "@mui/icons-material/FilterList";
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import MenuItem from '@mui/material/MenuItem';
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { Statuses } from "./constant";
// import Typography from "@mui/material/Typography";
// import { useNavigate } from "react-router-dom";
// import { UserRoles, Statuses } from "../../components/common/constant";
function CustomToolbar({ bulkDelete, onApproveAll, showSelectAll }) {
  //   const [exportMenuOpen, setExportMenuOpen] = React.useState(false);
  //   const exportMenuTriggerRef = React.useRef(null);
  
  const StyledQuickFilter = styled(QuickFilter)({
    display: "grid",
    alignItems: "center",
  });
  const StyledToolbarButton = styled(ToolbarButton)(
    ({ theme, ownerState }) => ({
      gridArea: "1 / 1",
      width: "min-content",
      height: "min-content",
      zIndex: 1,
      opacity: ownerState.expanded ? 0 : 1,
      pointerEvents: ownerState.expanded ? "none" : "auto",
      transition: theme.transitions.create(["opacity"]),
    })
  );

  const StyledTextField = styled(TextField)(({ theme, ownerState }) => ({
    gridArea: "1 / 1",
    overflowX: "clip",
    width: ownerState.expanded ? 260 : "var(--trigger-width)",
    opacity: ownerState.expanded ? 1 : 0,
    transition: theme.transitions.create(["width", "opacity"]),
  }));
  return (
    <Toolbar
      variant="dense"
      disableGutters
      sx={
        {
          // '@media (min-width: 600px)': {
          //    minHeight: '70px',
          // },
          // minHeight: '70px',
          // marginLeft: "10px",
          // marginTop: "10px"
        }
      }
    >
      {showSelectAll && (
        <Tooltip sx={{ flex: "1 1 100%" }} title={"Delete selected user(s)"}>
          <Button
            variant="contained"
            className="justifyStart btn btn-primary"
            size="medium"
            style={{ minHeight: "auto" }}
            onClick={onApproveAll}
            sx={{ marginRight: 2, textTransform: "none" }}
            disabled={!bulkDelete}
          >
            Delete selected user(s)
          </Button>
        </Tooltip>
      )}

      {showSelectAll && (
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ mx: 0.5 }}
        />
      )}

      <Tooltip title="Columns">
        <ColumnsPanelTrigger render={<ToolbarButton />}>
          <ViewColumnIcon fontSize="small" />
        </ColumnsPanelTrigger>
      </Tooltip>

      <Tooltip title="Filters">
        <FilterPanelTrigger
          render={(props, state) => (
            <ToolbarButton {...props} color="default">
              <Badge
                badgeContent={state.filterCount}
                color="primary"
                variant="dot"
              >
                <FilterListIcon fontSize="small" />
              </Badge>
            </ToolbarButton>
          )}
        />
      </Tooltip>

      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        sx={{ mx: 0.5 }}
      />

      <StyledQuickFilter>
        <QuickFilterTrigger
          render={(triggerProps, state) => (
            <Tooltip title="Search" enterDelay={0}>
              <StyledToolbarButton
                {...triggerProps}
                ownerState={{ expanded: state.expanded }}
                color="default"
                aria-disabled={state.expanded}
              >
                <SearchIcon fontSize="small" />
              </StyledToolbarButton>
            </Tooltip>
          )}
        />
        <QuickFilterControl
          render={({ ref, ...controlProps }, state) => (
            <StyledTextField
              {...controlProps}
              ownerState={{ expanded: state.expanded }}
              inputRef={ref}
              aria-label="Search"
              placeholder="Search..."
              size="small"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: state.value ? (
                    <InputAdornment position="end">
                      <QuickFilterClear
                        edge="end"
                        size="small"
                        aria-label="Clear search"
                        material={{ sx: { marginRight: -0.75 } }}
                      >
                        <CancelIcon fontSize="small" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ) : null,
                  ...controlProps.slotProps?.input,
                },
                ...controlProps.slotProps,
              }}
            />
          )}
        />
      </StyledQuickFilter>
    </Toolbar>
  );
}
const gridStyles = {
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#E0E0E0",
    fontWeight: "bold",
    fontSize: "0.95rem",
  },
  // Optional: Add border or shadow for extra flair
  //   "& .MuiDataGrid-columnHeader": {
  //     borderRight: "1px solid #e0e0e0",
  //   },

  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "#F3F3F5",
    borderBottom: "1px solid #E5E7EB",
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #E5E7EB",
  },
  "& .MuiDataGrid-row": {
    color: "#18181B",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "20px",
    verticalAlign: "middle",
  },
};


function CustomPagination({ rowCount = 0, paginationModel, setPaginationModel }) {
  const pageCount = Math.ceil(rowCount / paginationModel.pageSize) || 1;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      <Typography variant="body2">
        {rowCount > 0
          ? `Showing ${paginationModel.page * paginationModel.pageSize + 1} to ${Math.min(
            (paginationModel.page + 1) * paginationModel.pageSize,
            rowCount
          )} of ${rowCount} results`
          : "No results"}
      </Typography>

      <Pagination
        count={pageCount}
        page={paginationModel.page + 1} // DataGrid is 0-based, Pagination is 1-based
        onChange={(event, value) => setPaginationModel({ ...paginationModel, page: value - 1 })}
        color="primary"
        shape="rounded"
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{
              previous: () => <>Previous</>,
              next: () => <>Next</>,
            }}
          />
        )}
      />

    </Box>
  );
}

// const gridStyles = {
//   "& .MuiDataGrid-columnHeaders": {
//     backgroundColor: "#1976d2", // 🔵 Deep blue header
//     color: "#ffffff", // ⚪ White text
//     fontWeight: "bold",
//     fontSize: "0.95rem",
//   },
//   // Optional: Add border or shadow for extra flair
//   //   "& .MuiDataGrid-columnHeader": {
//   //     borderRight: "1px solid #e0e0e0",
//   //   },

//   "& .MuiDataGrid-row:nth-of-type(even)": {
//     backgroundColor: "#F2F5FA",
//     borderBottom: "1px solid #E5E7EB",
//   },
//   "& .MuiDataGrid-row:nth-of-type(odd)": {
//     backgroundColor: "#ffffff",
//     borderBottom: "1px solid #E5E7EB",
//   },
//   "& .MuiDataGrid-row": {
//     color: "#18181B",
//     fontWeight: "500",
//     fontSize: "16px",
//     lineHeight: "20px",
//     verticalAlign: "middle",
//   },
// };

export default function DynamicTable(props) {
  const [userList, setUserList] = React.useState([]);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: props.pageSize || 10,
  });
  const [loading, setLoading] = React.useState(true);
  const [zoomLevel, setZoomLevel] = React.useState(1);

  const ZOOM_STEP = 0.1;
  const MIN_ZOOM = 0.7;
  const MAX_ZOOM = 1.5;

  const {
    tableData,
    columnsValue,
    showSelectAll,
    handleCheckBoxSelection,
    pageSize,
    pageSizeOptions,
  } = props;

  React.useEffect(() => {
    setLoading(true);
    setUserList(tableData);
    setLoading(false);

    const newPageCount = Math.ceil(tableData?.length / paginationModel?.pageSize);
    if (paginationModel?.page >= newPageCount && newPageCount > 0) {
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }
  }, [tableData, paginationModel.pageSize]);

  const bulkDelete = selectedRows.length > 1;

  // Determine if checkboxes should be shown
  const shouldShowCheckboxes = props.module === "actionPlan" ? true : showSelectAll;

  // Compute zoomed column widths so horizontal scroll can reduce/disappear
  const scaledColumns = React.useMemo(() => {
    const scale = zoomLevel;
    const MIN_COL_WIDTH = 60;

    return (columnsValue || []).map((col) => {
      const updated = { ...col };

      if (typeof col.minWidth === "number") {
        updated.minWidth = Math.max(
          MIN_COL_WIDTH,
          Math.round(col.minWidth * scale)
        );
      }

      if (typeof col.width === "number") {
        updated.width = Math.max(
          MIN_COL_WIDTH,
          Math.round(col.width * scale)
        );
      }

      return updated;
    });
  }, [columnsValue, zoomLevel]);

  const handleSelectionModelChange = (selectionModel, setSelectedIds) => {
    let selectionArray = [];

    if (selectionModel.type === "include") {
      selectionArray = Array.from(selectionModel.ids);
    }

    if (selectionModel.type === "exclude") {
      selectionArray = userList.map((row) => row.id);
    }

    // Filter out rows with Completed status only for actionPlan module
    if (props.module === "actionPlan") {
      selectionArray = selectionArray.filter((id) => {
        const row = userList.find((r) => r.id === id);
        return row?.status !== "Completed";
      });
    }

    setSelectedRows(selectionArray);
    setSelectedIds(selectionArray);
  };

  const handleRowSelectionChangeForLeadDashboard = (
    selectionModel,
    userList,
    setSelectedIds,
    module
  ) => {
    const selectedIds = Array.from(selectionModel?.ids || []);

    if (module === "leadDashboard") {
      if (selectionModel.type === "include") {
        setSelectedIds(selectedIds);
      } else if (selectionModel.type === "exclude") {
        if (selectedIds.length === 0) {
          const allIds = userList.map((row) => row.rmsUserInfoId);
          setSelectedIds(allIds);
        } else {
          setSelectedIds((prev) =>
            prev.filter((id) => !selectedIds.includes(id))
          );
        }
      }
    } else {
      setSelectedIds(selectedIds);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        overflowX: "auto",
        "&:hover .zoom-controls": {
          opacity: 1,
          pointerEvents: "auto",
        },
      }}
    >
      <DataGrid
          rows={userList}
          loading={loading}
          columns={scaledColumns}
          getRowId={(row) =>
            props.module === "leadDashboard" ? row.rmsUserInfoId : row.id
          }
          // getRowHeight={() => "auto"}
          getRowHeight={() => props.rowHeight || "auto"}
          columnHeaderHeight={45}
          checkboxSelection={shouldShowCheckboxes}
          isRowSelectable={(params) => {
            if (props.module === "actionPlan") {
              return params.row.status === "Pending";
            }
            return true;
          }}
          getRowClassName={(params) => {
            let classes = "";
            if (props.module === "actionPlan" && params.row.status === "Completed") {
              classes += "action-plan-completed";
            }
            if ((props.module === "Inspections" || props.module === "AdminInProgress") && params.row.isOverDue && params.row.status !== Statuses.COMPLETED && params.row.status !== Statuses.CANCELLED) {
              classes += " row-overdue";
            }
            return classes;
          }}
          selectionModel={selectedRows}
          onRowSelectionModelChange={(selectionModel) =>
            props.module === "leadDashboard"
              ? handleRowSelectionChangeForLeadDashboard(
                  selectionModel,
                  userList,
                  props.setSelectedIds,
                  props.module
                )
              : handleSelectionModelChange(selectionModel, props.setSelectedIds)
          }
          disableRowSelectionOnClick
          hideFooterPagination
          hideFooterSelectedRowCount
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          slotProps={{
            loadingOverlay: {
              variant: "linear-progress",
              noRowsVariant: "linear-progress",
            },
            filterPanel: {
              placement: "bottom-start",
              disablePortal: true,
            },
          }}
          slots={{
            filterPanel: GridFilterPanel,
            toolbar: () => (
              <CustomToolbar
                bulkDelete={bulkDelete}
                onApproveAll={() => handleCheckBoxSelection(selectedRows)}
                showSelectAll={showSelectAll}
              />
            ),
          }}
          pageSize={pageSize || 10}
          pageSizeOptions={
            pageSizeOptions || [5, 10, 20, { value: -1, label: "All" }]
          }
          sx={{
            display: "grid",
            boxShadow: 2,
            width: "100%",
            borderRadius: 1,
            ...gridStyles,
            "& .MuiDataGrid-row": {
              minHeight: `${30 * zoomLevel}px`,
              fontSize: `${16 * zoomLevel}px`,
            },
            "& .MuiDataGrid-columnHeaders": {
              fontSize: `${0.95 * zoomLevel}rem`,
            },
            "& .action-plan-completed .MuiCheckbox-root": {
              display: "none !important",
            },
            "& .row-overdue": {
              backgroundColor: "#E520201A !important",
              "& td": {
                backgroundColor: "#E520201A !important",
              },
            },
          }}
          initialState={{
            pagination: { paginationModel: { pageSize: pageSize || 10 } },
          }}
           localeText={{
              noRowsLabel: "No data found",
            }}
        />

      <CustomPagination
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        rowCount={userList?.length}
      />

      <Box
        className="zoom-controls"
        sx={{
          position: "absolute",
          bottom: 80,
          right: 8,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          opacity: 0,
          pointerEvents: "none",
          transition: "opacity 0.2s ease",
        }}
      >
        <Button
          variant="contained"
          size="small"
          onClick={() =>
            setZoomLevel((prev) => Math.min(prev + ZOOM_STEP, MAX_ZOOM))
          }
          sx={{
            minWidth: 0,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            color: "#000000",
            boxShadow: 1,
            "&:hover": {
              backgroundColor: "#ffffff",
              boxShadow: 2,
            },
          }}
        >
          <ZoomInIcon fontSize="small" />
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() =>
            setZoomLevel((prev) => Math.max(prev - ZOOM_STEP, MIN_ZOOM))
          }
          sx={{
            minWidth: 0,
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            color: "#000000",
            boxShadow: 1,
            "&:hover": {
              backgroundColor: "#ffffff",
              boxShadow: 2,
            },
          }}
        >
          <ZoomOutIcon fontSize="small" />
        </Button>
      </Box>
    </Box>
  );
}
